'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_EmailLinkSignInError() {
}
export { $c_Lapp_data_EmailLinkSignInError as $c_Lapp_data_EmailLinkSignInError };
$p = $c_Lapp_data_EmailLinkSignInError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_EmailLinkSignInError;
/** @constructor */
function $h_Lapp_data_EmailLinkSignInError() {
}
export { $h_Lapp_data_EmailLinkSignInError as $h_Lapp_data_EmailLinkSignInError };
$h_Lapp_data_EmailLinkSignInError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-Email-Link-Sign-In-Error.js.map
